import _ from "lodash";
import { create } from "zustand";
import { DialogProps, DialogType } from "../../../Common/models/dialogs";

export interface State {
  dialogId?: string;
  isOpen: boolean;
  type: DialogType;
  classNameProp?: string;
  confirmLabel?: string;
  confirmNoLabel?: string;
  confirmYesLabel?: string;
  component?: React.ReactNode;
  dialogIcon?: React.ReactNode;
  darkBackground?: boolean;
  noDismiss?: boolean;
  reverseColorOption?: boolean;
  btnColumn?: boolean;

  showDialog: (props: DialogProps) => void;
  hideDialog: () => void;
  setType: (type: DialogType) => void;

  onPressConfirm?: () => void;
  onPressNo?: () => void;
  onPressYes?: () => void;
}

export const useDialogStore = create<State>((set) => ({
  isOpen: false,
  type: "Confirm",
  dialogId: "",
  setType: (type: DialogType) => {
    set((state) => ({ ...state, type }));
  },
  showDialog: (props: DialogProps) =>
    set((state) => ({
      ...state,
      ...props,
      isOpen: true,
    })),
  hideDialog: () =>
    set((state) => ({
      ...state,
      isOpen: false,
      classNamePropProp: undefined,
      confirmLabel: undefined,
      confirmNoLabel: undefined,
      confirmYesLabel: undefined,
      component: undefined,
      dialogIcon: undefined,
      darkBackground: undefined,
      noDismiss: undefined,
      reverseColorOption: undefined,
      btnColumn: undefined,
    })),
}));
